// extracted by mini-css-extract-plugin
module.exports = {"page":"dmbc-page","actions":"dmbc-page-actions","item":"dmbc-page-item","icon":"dmbc-page-icon","badge":"dmbc-page-badge"};